import React from "react";
import { CLINIC_ADDRESS, CLINIC_NAME_ENGLISH } from "./ClinicPrintHeader";

interface BillSupplyHeaderProps {
  documentTitle?: string;
}

const BillSupplyHeader: React.FC<BillSupplyHeaderProps> = ({ documentTitle }) => {
  return (
    <div className="border-b-2 border-[#2d2a78] pb-3 text-center text-[#2d2a78]">
      <div className="text-[30px] font-black uppercase leading-tight">{CLINIC_NAME_ENGLISH}</div>
      <div className="mt-2 text-sm font-semibold text-text-light">{CLINIC_ADDRESS}</div>
      {documentTitle && <div className="mt-3 text-lg font-black">{documentTitle}</div>}
    </div>
  );
};

export default BillSupplyHeader;
